import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSessionState } from '../hooks/useSessionState';
import RibbonActions from '../components/RibbonActions';
import FiltroPanel from '../components/FiltroPanel';
import { getOrdenesTaller, createOrdenTaller, getVehiculos, createVehiculo } from '../services/api';

const COLS = [
  ['recepcion','Recepción'], ['diagnostico','Diagnóstico'], ['cotizacion','Cotización'],
  ['aprobada','Aprobada'], ['en_proceso','En proceso'], ['control','Control'],
  ['lista','Lista'], ['entregada','Entregada'],
];
const EC = {
  recepcion:'#3b82f6', diagnostico:'#8b5cf6', cotizacion:'#f59e0b', aprobada:'#14b8a6',
  en_proceso:'#f97316', control:'#eab308', lista:'#10b981', entregada:'#64748b', cancelada:'#ef4444',
};
const fmt = (n) => '$' + Number(n || 0).toLocaleString('es-CO');

export default function Taller() {
  const nav = useNavigate();
  const [lista, setLista] = useState([]);
  const [busq, setBusq] = useSessionState('taller_busq', '');
  const [modal, setModal] = useState(false);
  const [saving, setSaving] = useState(false);

  // selección / creación de vehículo dentro del modal
  const [vehBusq, setVehBusq] = useState('');
  const [vehMatches, setVehMatches] = useState([]);
  const [veh, setVeh] = useState(null);            // vehículo seleccionado
  const [nuevoVeh, setNuevoVeh] = useState(false);
  const [vForm, setVForm] = useState({ placa:'', tipo:'auto', marca:'', linea:'', modelo_anio:'' });
  const [form, setForm] = useState({ motivo:'', km_entrada:'', fecha_entrega_estimada:'' });

  const load = () => getOrdenesTaller().then(r => setLista(r.data));
  useEffect(() => { load(); }, []);

  useEffect(() => {
    if (!modal) return;
    const t = setTimeout(() => { getVehiculos(vehBusq ? { busq: vehBusq } : {}).then(r => setVehMatches(r.data.slice(0, 8))); }, 200);
    return () => clearTimeout(t);
  }, [vehBusq, modal]);

  const abrirModal = () => {
    setVeh(null); setNuevoVeh(false); setVehBusq('');
    setVForm({ placa:'', tipo:'auto', marca:'', linea:'', modelo_anio:'' });
    setForm({ motivo:'', km_entrada:'', fecha_entrega_estimada:'' });
    setModal(true);
  };

  const crear = async () => {
    setSaving(true);
    try {
      let vehiculo_id = veh?.id;
      if (nuevoVeh) {
        if (!vForm.placa) { setSaving(false); return alert('La placa es requerida'); }
        const r = await createVehiculo(vForm);
        vehiculo_id = r.data.id;
      }
      if (!vehiculo_id) { setSaving(false); return alert('Selecciona o registra un vehículo'); }
      const r = await createOrdenTaller({ vehiculo_id, ...form });
      setModal(false);
      nav(`/taller/${r.data.id}`);
    } catch (e) { alert(e.response?.data?.error || 'Error al crear la orden'); }
    finally { setSaving(false); }
  };

  const filtradas = lista.filter(o => {
    if (!busq) return true;
    const t = (busq || '').toLowerCase();
    return [o.numero, o.placa, o.marca, o.linea, o.cliente_nombre].some(x => (x || '').toLowerCase().includes(t));
  });
  const porEstado = (e) => filtradas.filter(o => o.estado === e);

  return (
    <div>
      <div style={s.pageHeader}>
        <div><h1 style={s.h1}>Taller — Órdenes de servicio</h1><p style={s.sub}>Tablero por etapas</p></div>
        <RibbonActions><div style={{ display:'flex', gap:8, alignItems:'center' }}>
          <FiltroPanel fields={[{ tipo:'input', value:busq, onChange:setBusq, placeholder:'Buscar placa, número, cliente…' }]} onClear={() => setBusq('')} />
          <button style={s.btnPrimary} onClick={abrirModal}>+ Nueva orden</button>
        </div></RibbonActions>
      </div>

      <div style={s.board}>
        {COLS.map(([key, label]) => {
          const items = porEstado(key);
          return (
            <div key={key} style={s.column}>
              <div style={s.colHead}>
                <span style={{ ...s.dot, background:EC[key] }} />{label}
                <span style={s.count}>{items.length}</span>
              </div>
              <div style={s.colBody}>
                {items.map(o => (
                  <div key={o.id} style={s.cardOT} onClick={() => nav(`/taller/${o.id}`)}>
                    <div style={s.cardTop}>
                      <span style={s.numero}>{o.numero}</span>
                      <span style={s.placa}>{o.placa || '—'}</span>
                    </div>
                    <div style={s.cardVeh}>{[o.marca, o.linea].filter(Boolean).join(' ') || 'Vehículo sin datos'}</div>
                    <div style={s.cardCli}>{o.cliente_nombre || 'Sin cliente'}</div>
                    <div style={s.cardBot}>
                      <span style={{ color:'#94a3b8', fontSize:11 }}>{o.motivo ? (o.motivo.length > 36 ? o.motivo.slice(0,36)+'…' : o.motivo) : ''}</span>
                      <span style={s.total}>{fmt(o.total)}</span>
                    </div>
                  </div>
                ))}
                {items.length === 0 && <div style={s.colEmpty}>—</div>}
              </div>
            </div>
          );
        })}
      </div>

      {modal && (
        <div style={s.overlay}>
          <div style={s.modal}>
            <div style={s.modalHeader}>
              <h2 style={s.modalTitle}>Nueva orden de servicio</h2>
              <button style={s.closeBtn} onClick={() => setModal(false)}>✕</button>
            </div>
            <div style={s.modalBody}>
              {!nuevoVeh ? (
                <>
                  <div style={s.field}>
                    <label style={s.label}>Vehículo (buscar por placa / marca)</label>
                    <input style={s.input} value={vehBusq} onChange={e => { setVehBusq(e.target.value); setVeh(null); }} placeholder="Ej. ABC123" autoFocus />
                  </div>
                  {veh ? (
                    <div style={s.vehSel}>
                      <b style={{ color:'#f1f5f9' }}>{veh.placa}</b> · {[veh.marca, veh.linea].filter(Boolean).join(' ') || 'sin datos'}
                      {veh.cliente_nombre ? <span style={{ color:'#64748b' }}> · {veh.cliente_nombre}</span> : null}
                      <button style={s.linkBtn} onClick={() => setVeh(null)}>cambiar</button>
                    </div>
                  ) : (
                    <div style={s.matches}>
                      {vehMatches.map(v => (
                        <div key={v.id} style={s.match} onClick={() => { setVeh(v); setVehBusq(v.placa); }}>
                          <b style={{ color:'#93c5fd' }}>{v.placa}</b> · {[v.marca, v.linea].filter(Boolean).join(' ') || 'sin datos'}
                          {v.cliente_nombre ? <span style={{ color:'#64748b' }}> · {v.cliente_nombre}</span> : null}
                        </div>
                      ))}
                      {vehMatches.length === 0 && <div style={{ color:'#475569', fontSize:12, padding:'6px 2px' }}>Sin coincidencias</div>}
                    </div>
                  )}
                  <button style={s.linkBtn} onClick={() => setNuevoVeh(true)}>+ Registrar vehículo nuevo</button>
                </>
              ) : (
                <>
                  <div style={s.row2}>
                    <div style={s.field}><label style={s.label}>Placa *</label>
                      <input style={s.input} value={vForm.placa} onChange={e => setVForm({ ...vForm, placa:e.target.value.toUpperCase() })} autoFocus /></div>
                    <div style={s.field}><label style={s.label}>Tipo</label>
                      <select style={s.input} value={vForm.tipo} onChange={e => setVForm({ ...vForm, tipo:e.target.value })}>
                        {['auto','moto','camion','maquinaria','otro'].map(t => <option key={t} value={t}>{t}</option>)}
                      </select></div>
                  </div>
                  <div style={s.row2}>
                    <div style={s.field}><label style={s.label}>Marca</label>
                      <input style={s.input} value={vForm.marca} onChange={e => setVForm({ ...vForm, marca:e.target.value })} /></div>
                    <div style={s.field}><label style={s.label}>Línea</label>
                      <input style={s.input} value={vForm.linea} onChange={e => setVForm({ ...vForm, linea:e.target.value })} /></div>
                  </div>
                  <button style={s.linkBtn} onClick={() => setNuevoVeh(false)}>← Buscar un vehículo existente</button>
                </>
              )}

              <div style={{ borderTop:'1px solid #334155', margin:'12px 0' }} />
              <div style={s.field}><label style={s.label}>Motivo / falla reportada</label>
                <textarea style={{ ...s.input, minHeight:60, resize:'vertical' }} value={form.motivo} onChange={e => setForm({ ...form, motivo:e.target.value })} /></div>
              <div style={s.row2}>
                <div style={s.field}><label style={s.label}>Km de entrada</label>
                  <input style={s.input} type="number" value={form.km_entrada} onChange={e => setForm({ ...form, km_entrada:e.target.value })} /></div>
                <div style={s.field}><label style={s.label}>Entrega estimada</label>
                  <input style={s.input} type="date" value={form.fecha_entrega_estimada} onChange={e => setForm({ ...form, fecha_entrega_estimada:e.target.value })} /></div>
              </div>
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => setModal(false)}>Cancelar</button>
              <button style={{ ...s.btnPrimary, opacity: saving ? 0.7 : 1 }} onClick={crear} disabled={saving}>{saving ? 'Creando…' : 'Crear orden'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  pageHeader:  { display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:6 },
  h1:          { color:'#f1f5f9', fontSize:24, fontWeight:700, margin:'0 0 4px' },
  sub:         { color:'#64748b', fontSize:14, margin:0 },
  btnPrimary:  { background:'#1d4ed8', color:'#fff', border:'none', borderRadius:8, padding:'10px 20px', fontSize:14, fontWeight:600, cursor:'pointer' },
  btnSecondary:{ background:'#334155', color:'#cbd5e1', border:'none', borderRadius:8, padding:'10px 20px', fontSize:14, cursor:'pointer' },
  board:       { display:'flex', gap:12, overflowX:'auto', paddingBottom:12 },
  column:      { minWidth:220, width:220, flex:'0 0 auto', background:'#162032', borderRadius:12, display:'flex', flexDirection:'column' },
  colHead:     { display:'flex', alignItems:'center', gap:6, padding:'10px 12px', color:'#cbd5e1', fontSize:13, fontWeight:600, borderBottom:'1px solid #243044' },
  dot:         { width:8, height:8, borderRadius:8, display:'inline-block' },
  count:       { marginLeft:'auto', background:'#0f172a', color:'#94a3b8', borderRadius:10, padding:'1px 8px', fontSize:11 },
  colBody:     { padding:8, display:'flex', flexDirection:'column', gap:8, minHeight:60 },
  colEmpty:    { color:'#334155', textAlign:'center', fontSize:12, padding:'8px 0' },
  cardOT:      { background:'#1e293b', border:'1px solid #334155', borderRadius:10, padding:'8px 10px', cursor:'pointer' },
  cardTop:     { display:'flex', justifyContent:'space-between', alignItems:'center' },
  numero:      { color:'#93c5fd', fontWeight:600, fontSize:12 },
  placa:       { background:'#0f172a', border:'1px solid #334155', color:'#f1f5f9', borderRadius:4, padding:'1px 6px', fontSize:12, fontWeight:700, letterSpacing:0.5 },
  cardVeh:     { color:'#e2e8f0', fontSize:13, marginTop:4 },
  cardCli:     { color:'#64748b', fontSize:11, marginTop:1 },
  cardBot:     { display:'flex', justifyContent:'space-between', alignItems:'center', marginTop:6 },
  total:       { color:'#10b981', fontWeight:600, fontSize:12 },
  overlay:     { position:'fixed', inset:0, background:'rgba(0,0,0,.7)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:100 },
  modal:       { background:'#1e293b', borderRadius:16, width:'90%', maxWidth:560, maxHeight:'90vh', display:'flex', flexDirection:'column', border:'1px solid #334155' },
  modalHeader: { display:'flex', justifyContent:'space-between', alignItems:'center', padding:'13px 20px', borderBottom:'1px solid #334155' },
  modalTitle:  { color:'#f1f5f9', fontSize:16, fontWeight:700, margin:0 },
  closeBtn:    { background:'transparent', border:'none', color:'#64748b', fontSize:18, cursor:'pointer' },
  modalBody:   { padding:'14px 20px', overflowY:'auto', flex:1 },
  modalFooter: { display:'flex', justifyContent:'flex-end', gap:10, padding:'12px 20px', borderTop:'1px solid #334155' },
  row2:        { display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 },
  field:       { marginBottom:10 },
  label:       { display:'block', color:'#94a3b8', fontSize:12, marginBottom:4, fontWeight:500 },
  input:       { width:'100%', height:34, padding:'0 12px', background:'#0f172a', border:'1px solid #334155', borderRadius:8, color:'#f1f5f9', fontSize:13, boxSizing:'border-box', outline:'none' },
  matches:     { display:'flex', flexDirection:'column', gap:4, marginBottom:8 },
  match:       { background:'#0f172a', border:'1px solid #243044', borderRadius:6, padding:'6px 10px', fontSize:13, color:'#cbd5e1', cursor:'pointer' },
  vehSel:      { background:'#0f172a', border:'1px solid #14532d', borderRadius:6, padding:'8px 10px', fontSize:13, color:'#cbd5e1', marginBottom:8 },
  linkBtn:     { background:'transparent', border:'none', color:'#60a5fa', fontSize:12, cursor:'pointer', padding:'2px 0' },
};
